export interface LegislationsOption {
  value: number;
  label: string;
}

export const LegislationsOptions: LegislationsOption[] = [
  {
    value: 0,
    label: 'Todos os conteúdos',
  },
  {
    value: 2,
    label: 'Dica Legal',
  },
  {
    value: 1,
    label: 'Jurisprudência',
  },
  {
    value: 3,
    label: 'Súmula',
  },
  {
    value: 4,
    label: 'Legislação',
  },
];
